<mbs-iteration-ctrl-button (buttonClick)="openSelectServiceModal()"
                           [disabled]="!enabled"
                           [editIconVisible]='true'
                           [bindLabel]="'serviceDisplayName'"
                           [selected]="includedServices"
                           [emptyLabel]="'shared:buttons.configure' | i18next">
</mbs-iteration-ctrl-button>
<div *ngIf="enabled && !includedServices.length"
     class="text-danger">
  {{ 'mbs-ui:rmm-custom-alerting.notConfigured' | i18next }}
</div>
<ng-template #selectServiceModalBody>


  <div class="row">
    <div class="col-4 mb-3"
         [formGroup]="form">
      <mbs-rmm-computer-select formControlName="computerSelection"
                               [clearable]="false"
                               [label]="'mbs-ui:rmm-custom-alerting.serviceModal.showServices' | i18next"
                               [placeholder]="'mbs-ui:snmp.form.placeholders.computerDiscovery' | i18next"
                               [appendTo]="appendTo"
                               [selectedId]="selectedComputerHid">
      </mbs-rmm-computer-select>
    </div>
  </div>

  <div class="row">

    <div class="col-4">

      <div class="row mb-3">
        <div class="col-12"
             [formGroup]="form">
          <mbs-input formControlName="serviceSearch"
                     [placeholder]="'mbs-ui:rmm-custom-alerting.serviceModal.searchPlaceholder' | i18next">
          </mbs-input>
        </div>
      </div>

      <mbs-table-grid class="ph-no-capture"
                      [loading]="loading"
                      [headers]="serviceHeaders"
                      [data]="data"
                      [keepState]="true"
                      [showTableCheckboxes]="false"
                      [multipleSelect]="true"
                      [isNeedSelectRow]="true"
                      [bindSelected]="'serviceName'"
                      [selectedItems]="selectionFromList"
                      (changeSelected)="handleChangeSelectedExamples($event)"
                      (sort)="handleSort($event)"
                      [virtualScrolling]="virtualScrolling"
                      [virtualItemSize]="40"
                      [maxHeight]="'60vh'"
                      [noDataMessage]="'mbs-ui:notifications.noTableData' | i18next">

        <ng-template mbsTableCell
                     let-item>
          <mbs-text-ellipsis [tooltip]="item?.serviceName">
            {{ item?.serviceDisplayName }}
          </mbs-text-ellipsis>
        </ng-template>

        <ng-template mbsTableCell
                     let-item>
          <mbs-text-ellipsis [tooltip]="item?.name">
            {{ item?.serviceName }}
          </mbs-text-ellipsis>
        </ng-template>

      </mbs-table-grid>
    </div>

    <div class="col-1 d-flex flex-column justify-content-center align-items-center">
      <mbs-button class="mb-2"
                  [disabled]="!selectionFromList.length"
                  (click)="addToIncludeList($event)">
        {{ 'shared:buttons.add' | i18next }}
        <span class="fa fa-long-arrow-right ml-1"></span>
      </mbs-button>
      <mbs-button [disabled]="!selectionFromIncludeList.length"
                  (click)="removeFromIncludeList($event)">
        {{ 'shared:buttons.remove' | i18next }}
      </mbs-button>
    </div>

    <div class="col-7">

      <div class="row mb-3"
           [formGroup]="form">
        <div class="col-6">
          <mbs-input formControlName="includedServiceSearch"
                     [placeholder]="'mbs-ui:rmm-custom-alerting.serviceModal.searchPlaceholder' | i18next">
          </mbs-input>
        </div>
        <div class="col-6">
          <mbs-button (click)="addNewService()">
            {{ 'mbs-ui:rmm-custom-alerting.serviceModal.addServiceManually' | i18next }}
          </mbs-button>
        </div>
      </div>



      <mbs-table-grid class="ph-no-capture"
                      [loading]="loadingIncluded"
                      [headers]="headers"
                      [data]="includedData"
                      [keepState]="false"
                      [showTableCheckboxes]="false"
                      [multipleSelect]="true"
                      [isNeedSelectRow]="true"
                      [bindSelected]="'serviceName'"
                      [selectedItems]="selectionFromIncludeList"
                      (changeSelected)="handleChangeSelectedServices($event)"
                      (sort)="handleIncludedSort($event)"
                      [virtualScrolling]="true"
                      [virtualItemSize]="40"
                      [maxHeight]="'60vh'"
                      [noDataMessage]="'mbs-ui:notifications.noTableData' | i18next">

        <ng-template mbsTableHeader="Stopped"
                     let-header>
          <div [sortable]="header.sort"
               class="text-end">
            <div [ngbTooltip]="'mbs-ui:rmm-custom-alerting.serviceModal.stopColumnTooltip' | i18next"
                 [placement]="'bottom'"
                 tooltipClass="tooltip-lg"
                 container="body">
              {{ header.name }}
            </div>
          </div>
        </ng-template>

        <ng-template mbsTableCell
                     let-item>
          <mbs-text-ellipsis [tooltip]="item?.serviceName">
            {{ item?.serviceDisplayName }}
          </mbs-text-ellipsis>
        </ng-template>

        <ng-template mbsTableCell
                     let-item>
          <mbs-text-ellipsis [tooltip]="item?.name">
            {{ item?.serviceName }}
          </mbs-text-ellipsis>
        </ng-template>

        <ng-template mbsTableCell
                     let-item>
          <mbs-checkbox (change)="updateIncludedServicesList($event, serviceAlertType.Stop, item)"
                        [(ngModel)]="item.stop">
          </mbs-checkbox>
        </ng-template>

        <!-- <ng-template mbsTableCell
                     let-item>
          <mbs-checkbox (change)="updateIncludedServicesList($event, serviceAlertType.FailedStart, item)"
                        [(ngModel)]="item.failedStart">
          </mbs-checkbox>
        </ng-template>

        <ng-template mbsTableCell
                     let-item>
          <mbs-checkbox (change)="updateIncludedServicesList($event, serviceAlertType.FailedRestart, item)"
                        [(ngModel)]="item.failedRestart">
          </mbs-checkbox>
        </ng-template> -->

      </mbs-table-grid>
    </div>
  </div>
</ng-template>

<ng-template #addServiceFormBody>
  <div [formGroup]="addServiceForm">
    <div class="mb-3">
      <mbs-input formControlName="serviceDisplayName"
                 [label]="'mbs-ui:rmm-custom-alerting.serviceModal.displayNameLabel' | i18next"
                 [placeholder]="'mbs-ui:rmm-custom-alerting.serviceModal.displayNamePlaceholder' | i18next">
      </mbs-input>
    </div>
    <div>
      <mbs-input formControlName="serviceName"
                 [label]="'mbs-ui:rmm-custom-alerting.serviceModal.nameOptionalLabel' | i18next"
                 [placeholder]="'mbs-ui:rmm-custom-alerting.serviceModal.nameOptionalPlaceholder' | i18next">
      </mbs-input>
    </div>
  </div>
</ng-template>
